export enum ProjectModelFieldComponentMode {
  Read = 'read',
  Create = 'create',
  Update = 'update'
}
